var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3 7.926l5.162 5.773a.534.534 0 010 .696L19.3 20.17c-.277.31-.751.09-.751-.348v-4.86H.985a.985.985 0 010-1.968h17.564v-4.72c0-.438.474-.657.751-.347z",
    fill: "#1A1A1A"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS4zMDAxIDcuOTI1NzJMMjQuNDYyMiAxMy42OTk0QzI0LjYzNCAxMy44OTE2IDI0LjYzNCAxNC4yMDMyIDI0LjQ2MjIgMTQuMzk1NEwxOS4zMDAxIDIwLjE2OUMxOS4wMjI4IDIwLjQ3OTEgMTguNTQ4OCAyMC4yNTk1IDE4LjU0ODggMTkuODIxVjE0Ljk2MThIMC45ODQ1NThDMC40NDA4MDIgMTQuOTYxOCAwIDE0LjUyMSAwIDEzLjk3NzJDMCAxMy40MzM1IDAuNDQwODAxIDEyLjk5MjcgMC45ODQ1NTYgMTIuOTkyN0gxOC41NDg4VjguMjczNzRDMTguNTQ4OCA3LjgzNTI2IDE5LjAyMjggNy42MTU2NyAxOS4zMDAxIDcuOTI1NzJaIiBmaWxsPSIjMUExQTFBIi8+Cjwvc3ZnPgo=";
export { SvgArrow as ReactComponent };